// The dedicated wrapper service for `currentProject` state (TRD Section
// 2.4). This is the *only* module in the codebase permitted to import
// currentProjectSlice's actions or call useSelector/useDispatch against
// the `currentProject` branch of the store -- every other module reads
// via useCurrentProject() and writes via useCurrentProjectWriter()
// only. See docs/product/bugs/project-access-scoping-trd.md.
import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { set, clear } from './currentProjectSlice';

export const useCurrentProject = () => useSelector((state) => state.currentProject.value);

// Returns { setCurrentProject, clearCurrentProject } bound to dispatch.
// useDispatch()'s return value is referentially stable for the lifetime of
// the component (React-Redux guarantee), so memoizing on it keeps the
// returned writer object -- and therefore each of its two functions -- a
// stable reference across renders. This matters: several call sites in
// App.js put these functions in useCallback dependency arrays, and an
// unstable reference there would recreate those callbacks (and anything
// depending on them) on every render for no reason.
export const useCurrentProjectWriter = () => {
  const dispatch = useDispatch();
  return useMemo(() => ({
    setCurrentProject: (project) => dispatch(set(project)),
    clearCurrentProject: () => dispatch(clear()),
  }), [dispatch]);
};
